import alertIcon from 'assets/images/alert.svg';
import checkIcon from 'assets/images/check.svg';
import { rem, rgba, size } from 'polished';
import styled, { css } from 'styled-components';

export const InputWrapper = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colors.palette.white};
  border-radius: ${({ theme }) => theme.borderRadius.small};

  textarea {
    min-height: ${rem(150)};
    resize: vertical;
  }
`;

export const TextInputStyles = css`
  position: relative;
  z-index: 1;
  display: block;
  width: 100%;
  padding: ${rem(10)} ${rem(14)};
  padding-right: var(--input-right-padding);
  background-repeat: no-repeat;
  background-position: center right ${rem(14)};
  background-size: ${rem(16)};
  border: 1px solid ${({ theme }) => theme.colors.palette.grey};
  border-radius: inherit;
  outline: 0;

  &[aria-invalid] {
    --input-right-padding: ${rem(44)};
  }

  &[aria-invalid='false'] {
    background-color: ${({ theme }) => rgba(theme.colors.palette.green, 0.05)};
    background-image: url(${checkIcon});
    border-color: ${({ theme }) => theme.colors.palette.green};
  }

  &[aria-invalid='true'] {
    background-color: ${({ theme }) =>
      rgba(theme.colors.palette.redDark, 0.05)};
    background-image: url(${alertIcon});
    border-color: ${({ theme }) => theme.colors.palette.redDark};
  }

  &:focus,
  .focus & {
    --focus-color: ${({ theme }) => theme.colors.palette.teal};

    background-color: ${({ theme }) => rgba(theme.colors.palette.teal, 0.05)};
    border-color: ${({ theme }) => theme.colors.palette.teal};
  }

  &:disabled {
    color: ${({ theme }) => theme.colors.palette.grey};
    background-color: ${({ theme }) =>
      rgba(theme.colors.palette.greyLight, 0.3)};
  }
`;

export const Input = styled.input`
  ${TextInputStyles}
`;

interface WrapperProps {
  hasIconPadding?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
  --input-right-padding: ${({ hasIconPadding }) =>
    hasIconPadding ? rem(44) : rem(14)};

  position: relative;
  z-index: ${({ theme }) => theme.zIndex[1]};
  text-align: left;

  & + & {
    margin-top: ${rem(24)};
  }

  ${Input} {
    ${({ hasIconPadding }) =>
      hasIconPadding &&
      css`
        background-image: none;
      `}
  }
`;

export const Label = styled.label`
  display: block;
  margin-bottom: ${rem(4)};
`;

export const Error = styled.div`
  position: relative;
  top: -1px;
  z-index: -1;
  padding: ${rem(8)} ${rem(14)};
  color: ${({ theme }) => theme.colors.palette.redDark};
  font-weight: bold;
  background-color: ${({ theme }) => theme.colors.palette.white};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  box-shadow: 0 8px 15px 0 rgba(0, 53, 96, 0.15);
`;

interface PasswordToggleProps {
  isActive?: boolean;
}

export const PasswordToggle = styled.button<PasswordToggleProps>`
  ${size(rem(16))};

  position: absolute;
  top: 50%;
  right: ${rem(14)};
  z-index: ${({ theme }) => theme.zIndex[1]};
  background: none;
  border: 0;
  outline: 0;
  transform: translateY(-50%);
  cursor: pointer;
  opacity: ${({ isActive }) => (isActive ? 1 : 0.5)};

  svg {
    ${size('100%')};

    position: absolute;
    top: 0;
    left: 0;
  }
`;
